import { useEffect, useState } from 'react';
import { lerMinhasFaltas } from '../../faltas';
import type { MinhasFaltas } from '../../faltas';
import './faltas.css';

/**
 * MEU DESEMPENHO → "Registros de falta" (dono, 02/10/2026). Só os números da própria pessoa;
 * a posição aparece só se o admin deixou (privacidade do ranking) e o ranking inteiro só quando é
 * público. Participação — nunca dinheiro. Some quando não há campanha nem registro.
 */
export function CartaoDeFaltas() {
  const [m, setM] = useState<MinhasFaltas | null>(null);
  useEffect(() => {
    let vivo = true;
    void lerMinhasFaltas().then((r) => vivo && r.ok && setM(r.dados.faltas));
    return () => {
      vivo = false;
    };
  }, []);
  if (!m || (m.registrosTotal === 0 && !m.campanha)) return null;
  const c = m.campanha;
  const prox = c?.progresso.proxima;
  const base = c?.progresso.atual?.minimo ?? 0;
  const pct =
    c && prox ? Math.min(100, Math.round(((c.validas - base) / (prox.minimo - base)) * 100)) : 100;
  return (
    <section className="dp-cartao ft-meu" aria-label="Registros de falta">
      <div className="dp-conq-rotulo">
        REGISTROS DE FALTA{c ? ` · ${c.nome.toUpperCase()}` : ''}
      </div>
      <div className="ft-meu-numeros">
        <div>
          <span>Registros</span>
          <b>{String(c ? c.validas : m.registros30)}</b>
          <small>{c ? 'válidos na campanha' : 'nos últimos 30 dias'}</small>
        </div>
        {c && (
          <div>
            <span>Posição</span>
            <b>{c.posicao !== null ? `${String(c.posicao)}º` : '—'}</b>
            <small>
              {c.posicao !== null && c.participantes
                ? `de ${String(c.participantes)}`
                : c.rankingVisibilidade === 'SO_ADMIN'
                  ? 'ranking só do admin'
                  : 'registre a 1ª'}
            </small>
          </div>
        )}
        {c && (
          <div>
            <span>Medalha atual</span>
            <b>
              {c.progresso.atual ? `${c.progresso.atual.emoji} ${c.progresso.atual.nome}` : '—'}
            </b>
          </div>
        )}
        {c && (
          <div>
            <span>Próxima medalha</span>
            <b>{prox ? `${prox.emoji} ${prox.nome}` : 'Todas ganhas'}</b>
            {prox && c.progresso.faltam !== null && (
              <small>
                {String(c.progresso.faltam)}{' '}
                {c.progresso.faltam === 1 ? 'registro restante' : 'registros restantes'}
              </small>
            )}
          </div>
        )}
      </div>
      {c && prox && (
        <div className="ft-barra" aria-hidden="true">
          <i style={{ width: `${String(Math.max(0, pct))}%` }} />
        </div>
      )}
      {c?.ranking && c.ranking.length > 0 && (
        <ol className="ft-ranking">
          {c.ranking.slice(0, 5).map((x) => (
            <li key={`${String(x.posicao)}-${x.nome}`}>
              <span className="ft-pos">{String(x.posicao)}º</span>
              <b>{x.euMesmo ? `${x.nome} (você)` : x.nome}</b>
              <span className="enc-mono">{String(x.validas)}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
